
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cancel-subscription",
      function () {
        return require("private-next-pages/cancel-subscription.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cancel-subscription"])
      });
    }
  